import Grid from '@mui/material/Grid';
import FormikDropdown from 'components/inputs/FormikDropdown';
import LastUpdatedLabel from 'components/LastUpdatedLabel';
import Panel from 'components/Panel';
import selectors from 'features/layout/redux/selectors';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {default as licenseSelectors} from 'redux/license/selectors';
import {settingsActions} from 'redux/settings';
import {default as settingsSelectors} from 'redux/settings/selectors';
import {DiplomatFeature} from 'types/DiplomatFeature';
import {KeySettings, keySettingsSchema} from 'types/KeySettings';
import {DialogTypes} from 'common/names';
import Dialog from 'components/Dialog';
import {useSendData} from 'features/layout/CommonPage/redux/hooks/useSendData';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import Formik from 'components/hook-form/Formik';
import {useTranslation} from 'react-i18next';

type DialogProps = {
   ok: (values: KeySettings, callbacks: any) => any;
   cancel: () => void;
};

const SettingsOpenPGPKeys = ({ok, cancel}: DialogProps) => {
   const {t} = useTranslation();
   const settings = useSelector(settingsSelectors.keySettings);
   const {openpgp: {secretKeys = []} = {}} = useSelector(selectors.keysSelector);
   const isFeatureSupported = useSelector(licenseSelectors.isFeatureSupported);
   const dispatch = useDispatch();
   React.useEffect(() => {
      dispatch(settingsActions.getKeySettings());
   }, [dispatch]);

   return (
      <Formik
         initialValues={settings}
         onSubmit={(values, callbacks) => {
            return ok(values, callbacks);
         }}
         validationSchema={keySettingsSchema}
         enableReinitialize
      >
         <>
            <Panel>
               <Grid container spacing={2}>
                  <Grid item xs={12}>
                     <FormikDropdown
                        autoFocus
                        label={t('Default Decryption Key')}
                        name="decryptionKeyId"
                        options={secretKeys}
                        includeEmptyValue
                     />
                  </Grid>
                  <Grid item xs={12}>
                     <FormikDropdown
                        label={t('Default Signature Key')}
                        name="signatureKeyId"
                        options={secretKeys}
                        includeEmptyValue
                     />
                  </Grid>
                  {isFeatureSupported(DiplomatFeature.AEKS) ? (
                     <Grid item xs={12}>
                        <FormikDropdown
                           label={t('Default Additional Encryption Key (AEK)')}
                           name="additionalEncryptionKeyId"
                           options={secretKeys}
                           includeEmptyValue
                        />
                     </Grid>
                  ) : null}
                  <Grid item xs={12}>
                     <LastUpdatedLabel date={settings.timestamp} author={settings.lastUser} />
                  </Grid>
               </Grid>
            </Panel>
            <FormFooterButtons cancel={cancel} />
         </>
      </Formik>
   );
};

type Props = {
   onClose: () => void;
};
export const SettingsOpenPGPKeysDialog = ({onClose}: Props) => {
   const sendData = useSendData();
   return (
      <Dialog maxWidth="sm" header={DialogTypes.SettingsOpenPGPKeys.dialogName} close={onClose}>
         <SettingsOpenPGPKeys
            ok={(values, callbacks) => {
               sendData(DialogTypes.SettingsOpenPGPKeys.id, values, callbacks);
               onClose();
            }}
            cancel={onClose}
         />
      </Dialog>
   );
};
export default React.memo(SettingsOpenPGPKeysDialog);
